const actions = {

	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu
	updateVerticalNavMenuWidth ({ commit }, width) {
		commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width);
	},

	// VxAutoSuggest
	/*updateStarredPage ({ commit }, payload) {
		commit('UPDATE_STARRED_PAGE', payload);
	},
	// The Navbar
	arrangeStarredPagesLimited ({ commit }, list) {
		commit('ARRANGE_STARRED_PAGES_LIMITED', list);
	},
	arrangeStarredPagesMore ({ commit }, list) {
		commit('ARRANGE_STARRED_PAGES_MORE', list);
	},*/

	// /////////////////////////////////////////////
	// UI
	// /////////////////////////////////////////////

	toggleContentOverlay ({ commit }) {
		commit('TOGGLE_CONTENT_OVERLAY');
	},
	updateTheme ({ commit }, val) {
		commit('UPDATE_THEME', val);
	},

	updateFavoritePage ({ commit }, payload) {
		commit('UPDATE_FAVORITE_PAGE', payload);
	},
	clearFavorites ({ commit }) {
		commit('CLEAR_FAVORITES');
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	updateUserInfo ({ commit }, payload) {
		//console.log('updateUserInfo', this._vm);
		commit('UPDATE_USER_INFO', payload);
	},
	updateUserRole ({ dispatch }, payload) {
		// Change client side
		payload.aclChangeRole(payload.userRole);
		//this.$acl.change
		// Make API call to server for changing role

		// Change userInfo in localStorage and store
		dispatch('updateUserInfo', { userRole: payload.userRole });
	},
};

export default actions;
